import PrimaryButton from "../../../reusableUi/PrimaryButton";
import { Phone, Plus, Minus } from "lucide-react";
import { useState } from "react";

const FAQS = [
  {
    question: "How do you ensure the quality of your plumbing work?",
    answer:
      "Every project is handled by skilled professionals who follow strict safety and quality protocols. We pay attention to detail to deliver reliable and long-lasting results.",
  },
  {
    question: "Do you offer emergency plumbing services?",
    answer:
      "Yes, we provide prompt response for urgent plumbing needs. Our team arrives quickly and works efficiently to resolve issues while maintaining safety and quality.",
  },
  {
    question: "How do you handle complex plumbing problems?",
    answer:
      "Our experienced plumbers assess each situation carefully and apply proven techniques. We prioritize accuracy, safety, and efficiency to provide lasting solutions.",
  },
  {
    question: "Are your services transparent and trustworthy?",
    answer:
      "Absolutely. We maintain clear communication, provide honest estimates, and explain each step of the work. Our goal is to ensure a smooth, reliable experience.",
  },
  {
    question: "Do you follow safety protocols on every job?",
    answer:
      "Yes. Safety is a top priority on all our projects. Our team uses proper protective equipment and follows industry standards to keep every site safe.",
  },
  {
    question: "What makes your plumbing services reliable?",
    answer:
      "Our combination of skilled professionals, attention to detail, and efficient processes ensures dependable results. Every job is completed thoroughly and carefully for your peace of mind.",
  },
];

export default function FAQs() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="faqs" className="max-w-[90%] xl:max-w-6xl mx-auto space-y-12">

      {/* Header row */}
        <div className="space-y-4">
          <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
            FAQs
          </div>
          <h2 className="font-black text-gray-900 text-4xl lg:text-5xl tracking-tight leading-tight">
            What People Ask
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed max-w-xl">
            Our services are built on trust, skill, and attention to detail. Honest, direct answers — every time.
          </p>
        </div>

        {/* Desktop CTA */}
          

      {/* Accordion */}
      <div className="space-y-3 w-full">
        {FAQS.map((faq, i) => (
          <div
            key={i}
            className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden"
          >
            <button
              onClick={() => toggle(i)}
              className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
            >
              <span className="font-bold text-gray-900 text-[15px] leading-snug">
                {faq.question}
              </span>
              <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors duration-200 ${openIndex === i ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-500"}`}>
                {openIndex === i
                  ? <Minus className="w-4 h-4" />
                  : <Plus className="w-4 h-4" />}
              </span>
            </button>

            {openIndex === i && (
              <div className="px-6 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-100 pt-4">
                  {faq.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
<div className="mt-6 bg-blue-50 border border-blue-100 rounded-2xl p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
  <div>
    <h3 className="font-black text-gray-900 text-xl leading-tight">Still have questions?</h3>
    <p className="text-gray-500 text-sm mt-1">Our team is happy to help — reach out anytime.</p>
  </div>
  <PrimaryButton />
</div>
    </section>
  );
}
